function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 32,
  r: 32,
  fill: "#2CC16B"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 32.5,
  cy: 26.348,
  r: 5,
  stroke: "#fff",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M41.968 43H23.032c.408-6.335 4.66-11 9.468-11s9.06 4.665 9.468 11z",
  stroke: "#fff",
  strokeWidth: 2
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 48.098,
  cy: 30.941,
  r: 3.441,
  stroke: "#fff",
  strokeWidth: 2
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M54.826 43.006H41.371c.398-4.454 3.42-7.622 6.728-7.622s6.33 3.168 6.727 7.622z",
  stroke: "#fff",
  strokeWidth: 2
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 16.772,
  cy: 30.941,
  r: 3.441,
  stroke: "#fff",
  strokeWidth: 2
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M23.5 43.006H10.043c.398-4.454 3.42-7.622 6.728-7.622s6.33 3.168 6.727 7.622z",
  stroke: "#fff",
  strokeWidth: 2
});

function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.3939a766.svg";
export { ForwardRef as ReactComponent };